import { BigDollarInput } from "@/components/BigDollarInput/BigDollarInput";
import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { QuestionTooltip } from "@/components/QuestionTooltip/QuestionTooltip";
import {
  cashFlowAtom,
  getPurchaseMultiple,
  listingPriceAtom,
  targetPurchaseMultipleAtom,
} from "@/financeModels/liteAtoms";
import { Group } from "@mantine/core";
import { useAtom, useSetAtom } from "jotai";

export const NumberInputCashFlow = ({
  showExplanation,
}: {
  showExplanation?: boolean;
}) => {
  const [listingPrice] = useAtom(listingPriceAtom);
  const [cashFlow, setCashFlow] = useAtom(cashFlowAtom);
  const setTargetPurchaseMultiple = useSetAtom(targetPurchaseMultipleAtom);

  return (
    <BigDollarInput
      value={typeof cashFlow === "number" ? cashFlow : undefined}
      onChange={(value) => {
        const newCashFlow = typeof value === "number" ? value : null;
        setCashFlow(newCashFlow);
        setTargetPurchaseMultiple(
          getPurchaseMultiple({
            price: listingPrice,
            cashFlow: newCashFlow,
          }),
        );
      }}
      label={
        <Group gap={2} align="center">
          {showExplanation && (
            <LabelExplainer
              showIcon
              label={"Cash Flow (SDE)"}
              explanation={<Doc path="@/docs/pages/home/cash-flow.mdx" />}
            />
          )}
          {!showExplanation && (
            <QuestionTooltip
              label={
                <>
                  Cash flow or Seller’s Discretionary Earnings refers to the
                  <br />
                  cash flow generated by a business before deducting owner's
                  <br />
                  discretionary expenses and other financial adjustments.
                </>
              }
            >
              Cash Flow (SDE)
            </QuestionTooltip>
          )}{" "}
          :
        </Group>
      }
    />
  );
};
